module.exports = __webpack_public_path__ + "media/images/hortense blanc-a1e9acb19bcb58f3b7c687cc873a1650.svg";